/**
 * @generated SignedSource<<0bfd8caef613b197ae30fe9973a32701>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxMonthlyBudget",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FundingSourceBudgetAccountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FundingSourceBudgetAccountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c699474aa2028567091d5c12595a5457",
    "id": null,
    "metadata": {},
    "name": "FundingSourceBudgetAccountUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FundingSourceBudgetAccountUpdateMutation(\n  $input: UpdateAccountTByAccountIdInput!\n) {\n  updateAccountTByAccountId(input: $input) {\n    accountT {\n      accountId\n      maxMonthlyBudget\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ed46c51e0a2885b800e95eb8d339e4e4";

module.exports = node;
